import apiV2 from "api-v2";

import type { ImportedQuoteTable } from "../types/imported-quote-table.type";
import { postAnalyzeMultipart, type QuoteImportApi } from "./quote-import-shared";

/**
 * RFx-template quote import — `rfx-template/{rfx_template_id}/quotes/import/*`.
 *
 * Mirrors `ai-spreadsheet-import-api.ts` for the relational RFx-template surface
 * (task 007). Mounted from the `CreateRFxTemplate.js` wizard QuoteTab
 * (`resourceType="rfx-template"`), it persists standalone `RfxQuote` tables bound
 * to `rfx_template_id` (no RFx association). Selected by `resolveQuoteImportApi`.
 */
export const createTemplateQuoteImportApi = (
	rfxTemplateId: number
): QuoteImportApi => ({
	analyze: (file) =>
		postAnalyzeMultipart(
			`rfx-template/${rfxTemplateId}/quotes/import/analyze`,
			file
		),
	apply: async (tables: ImportedQuoteTable[]) => {
		await apiV2.post(`rfx-template/${rfxTemplateId}/quotes/import/apply`, {
			tables,
		});
	},
});
